export default "__VITE_ASSET__2nEj2dAS__"